import React, {useState} from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Input, InputGroup, InputLeftElement} from "@chakra-ui/react";
import {Search as LucideSearch} from "lucide-react";
import {themecolors} from "../../utils/themecolors";
import useFeedback from "../../utils/use_feedback";
import {useAllCommunities, useCommunities, useCommunitySearch} from "../../api/communities";
import {useStoreProfile} from "../../store";
import Community from "../community";
import {Header} from "./sheet";

const Search = styled.div`;`
const List = styled.div``;

const SelectCommunitySheet = styled(({className, handleSelect, onClose}) => {

    const [query, setQuery] = useState('');

    // show subscriptions unless there's a search term

    const {error, feedbackCh} = useFeedback();
    const {communities, loading } = useAllCommunities(feedbackCh, 'alphabetical', 'subscribed');
    const {subscribed} = useStoreProfile();
    const subscribedCommunities = useCommunities(loading.channel, subscribed);
    const sorted = subscribedCommunities.sort((a, b) => (a.name > b.name) ? 1 : -1)

    const queryCommunities = useCommunitySearch(feedbackCh, query);

    const communityList = query.length > 0 ? queryCommunities : sorted;

    return (
        <div className={className}>

            <Header>

                <Search>
                    <form>
                        <InputGroup>
                            <InputLeftElement
                                pointerEvents="none"
                                style={{height: '40px', width: '50px'}}
                            ><LucideSearch size={20} /></InputLeftElement>
                            <Input focusBorderColor={'none'} type="text" placeholder="Search" transitionDuration={'0'}
                            value={query} onChange={(e) => setQuery(e.currentTarget.value)} />
                        </InputGroup>
                    </form>
                </Search>

            </Header>

            <List>

                    {communityList?.map((community) =>
                        community && community.visibility !== 'unlisted' && (
                            <Community
                                condensed
                                key={community.name}
                                community={community}
                                onClick={() => handleSelect(community.name) }
                            />
                        )
                    )}

            </List>

        </div>
    );
})`

  ${Header} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_1 : '#fff'};
    height: 82px;
    position: fixed;
    top: 0;
    width: 100%;
  }
  ${List} {
    margin-top: 52px;
  }
 ${Search} {
    line-height: initial;
    width: calc(100% - 32px);
  }

  ${Search} input {
    height: 40px;
    font-size: 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : themecolors.light_input};
    border: none;
    border-radius: 4px;
    padding: 0 46px;
  }
  
`;

export default SelectCommunitySheet;
